export class AbstractDataMask {
    _searchCondition;
    _maskingCharacter;
    constructor(searchCondition, maskingCharacter = '*') {
        this._searchCondition = searchCondition;
        this._maskingCharacter = maskingCharacter;
    }
    mask(text) {
        return text.replace(this._searchCondition, (substring) => this.maskSubstring(substring, this._maskingCharacter));
    }
}
